import React from "react";
import "./BrandsCarousel.css";

// Works in CRA + Vite + sub-folder deploys
const BASE =
  (typeof import.meta !== "undefined" && import.meta?.env?.BASE_URL) ||
  (typeof process !== "undefined" && process?.env?.PUBLIC_URL) ||
  "";

const img = (file) => {
  const b = String(BASE || "").replace(/\/$/, "");
  return `${b}/brands/${file}`;
};

const DEFAULT_BRANDS = [
  { name: "Arpico",   src: img("arpico.png"),   href: "#" },
  { name: "Asian",    src: img("asian.png"),    href: "#" },
  { name: "Lanva",    src: img("lanva.png"),    href: "#" },
  { name: "Remco",    src: img("remco.png"),    href: "#" },
  { name: "SLON",     src: img("slon.png"),     href: "#" },
  { name: "Swisstek", src: img("swisstek.png"), href: "#" },
];

export default function BrandsCarousel({
  items = DEFAULT_BRANDS,
  title = "Brands We Carry",
  sub = "Trusted brands for tools, paint, tiles, and building materials.",
  speed = "50s",
}) {
  const isExternal = (href) => /^https?:\/\//i.test(href);

  const Track = ({ dup = false }) => (
    <ul className="brands__track" aria-hidden={dup ? "true" : "false"}>
      {items.map((b, i) => (
        <li className="brands__card" key={(dup ? "dup-" : "") + b.name + i}>
          {b.href && b.href !== "#" ? (
            <a
              className="brands__link"
              href={b.href}
              {...(isExternal(b.href)
                ? { target: "_blank", rel: "noreferrer" }
                : {})}
              aria-label={b.name}
              title={b.name}
            >
              <img src={b.src} alt={b.name} loading="lazy" />
            </a>
          ) : (
            <img src={b.src} alt={b.name} loading="lazy" />
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <section className="brands" aria-label={title} style={{ "--speed": speed }}>
      <div className="brands__inner container">
        <div className="brands__head">
          <h3 className="brands__title">{title}</h3>
          {sub ? <p className="brands__sub">{sub}</p> : null}
        </div>

        <div className="brands__viewport">
          <Track />
          <Track dup />
        </div>
      </div>
    </section>
  );
}
